module.exports = __webpack_public_path__ + "static/media/industries-cheramic-s.474fa435.webp";